import type { Icon } from "@phosphor-icons/react";
import { ChartLineUpIcon } from "@phosphor-icons/react/dist/csr/ChartLineUp";
import { HandshakeIcon } from "@phosphor-icons/react/dist/csr/Handshake";
import { QuestionIcon } from "@phosphor-icons/react/dist/csr/Question";
import { ReceiptIcon } from "@phosphor-icons/react/dist/csr/Receipt";
import { WalletIcon } from "@phosphor-icons/react/dist/csr/Wallet";
import type { BusinessProduct } from "@/business/business";

export const helpTopicIcon = (product: BusinessProduct | undefined): Icon => {
  switch (product) {
    case "payroll":
      return WalletIcon;
    case "accounts_payable":
      return ReceiptIcon;
    case "profitability":
      return ChartLineUpIcon;
    case "referrals":
      return HandshakeIcon;
    case undefined:
      return QuestionIcon;
    default: {
      const exhaustive: never = product;
      return exhaustive;
    }
  }
};
